import * as React from "react"
import { t } from "ttag"

import { BaseProps } from "@humanpredictiveintelligence/myqvt-library"
import { ErroredMetricsCard } from "@humanpredictiveintelligence/myqvt-library"

export const ErroredScheduledSurveysCalendar: React.FC<BaseProps> = (props) => {
  return (
    <div className={props.className}>
      <ErroredMetricsCard title={t`Programmation`}>
        {t`An error has occurred.`}
      </ErroredMetricsCard>
    </div>
  )
}
